<div class="col-lg-12">
    <div class="d-flex related-title">
        {{title}}
    </div>
  <div class="d-flex justify-content-center">
    <p-carousel 
        [value]="products"
        [numVisible]="numSlides"
        [numScroll]="1"
        [circular]="true"
        [orientation]="isVertical ? 'vertical' : 'horizontal'" 
        verticalViewPortHeight="50rem"
        [responsiveOptions]="responsiveOptions"
        autoplayInterval="10000" class="w-100">
      <ng-template let-product pTemplate="item">
        <div class="border-related m-2 p-3">
          <div class="mb-3">
            <div class="mx-auto py-4 d-flex justify-content-center">
              <img [src]="product?.imagen?.url" [alt]="product?.nombre" class="border-round img-detail" />
            </div>
          </div>
          <div class="mb-3 font-medium">
            {{ product?.nombre }}
          </div>
          <div class="flex justify-content-between align-items-center">
            <div class="mt-0 font-medium">
              {{ product.precioUnitario | currency }}
            </div>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>
</div>

